var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext, useEffect, } from "react";
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { firebaseConfig } from "./FirebaseConfig";
import { DevDaemonDBController } from "./DevDaemonDBController";
var AUTH_CONTEXT_DEFAULT_VALUE = {
    app: initializeApp(firebaseConfig),
    user: null,
    db_ctrler: undefined,
    setDBCtrler: function (value) {
        value;
    }, // dummy function
};
var AuthContext = createContext(AUTH_CONTEXT_DEFAULT_VALUE);
export function useAuthContext() {
    return useContext(AuthContext);
}
export function AuthProvider(_a) {
    var children = _a.children;
    var app = initializeApp(firebaseConfig);
    var _b = useState(null), user = _b[0], setUser = _b[1];
    var _c = useState(new DevDaemonDBController(app)), db_ctrler = _c[0], setDBCtrler = _c[1];
    // TODO: useAuthContext内のuserをdb_ctrlerに統合する
    var value = {
        app: app,
        user: user,
        db_ctrler: db_ctrler,
        setDBCtrler: setDBCtrler,
    };
    useEffect(function () {
        var auth = getAuth(app);
        var unsubscribed = onAuthStateChanged(auth, function (user) {
            // サインイン時にはuserにユーザ情報が入り, サインアウト時にはnullが入る
            setUser(user);
        });
        return function () {
            unsubscribed();
        };
    }, []);
    return _jsx(AuthContext.Provider, __assign({ value: value }, { children: children }), void 0);
}



//////////////////
// WEBPACK FOOTER
// ./src/AuthContext.tsx
// module id = 7
// module chunks = 0